import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { APP_STORE } from '@core/stores/app.store';

export const CLIENT_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const appStore = inject(APP_STORE);

  const clientId = appStore.selectedClientId();
  if (clientId != null) {
    req = req.clone({
      setHeaders: {
        ClientId: clientId
      }
    });
  }

  return next(req);
};
